import { useEffect, useState } from "react";
import Nav from "@/components/monplaisir/Nav";
import Hero from "@/components/monplaisir/Hero";
import About from "@/components/monplaisir/About";
import Services from "@/components/monplaisir/Services";
import Fleet from "@/components/monplaisir/Fleet";
import EnquiryForm from "@/components/monplaisir/EnquiryForm";
import Partners from "@/components/monplaisir/Partners";
import Footer from "@/components/monplaisir/Footer";
import IntroOverlay from "@/components/monplaisir/IntroOverlay";

export default function Monplaisir() {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 40);
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <div className="bg-cream text-[#1A1A1A] min-h-screen">
            <IntroOverlay />
            <Nav scrolled={scrolled} />
            <main>
                <Hero />
                <About />
                <Services />
                <Fleet />
                <Partners />
                <EnquiryForm />
            </main>
            <Footer />
        </div>
    );
}
